// @file UTM capture entrypoint. Logic lives in bits/utm_capture so it can
// be unit-tested outside the vite-plugin-ruby entrypoint glob.
import window from '@@/bits/global'
import { captureUtmParams, stripUtmParamsFromUrl } from '@@/bits/utm_capture'

window.$utmParams = captureUtmParams()
stripUtmParamsFromUrl()
